module.exports = __webpack_public_path__ + "static/media/arrowDownProfile.e7a1e3fd.svg";